module.exports = __webpack_public_path__ + "img/img_cs_img5.041e2b5d.png";